import React, { useState } from "react";
//import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";
import {
  useIntl,
  Link,
  FormattedMessage,
  changeLocale,
} from "gatsby-plugin-react-intl";
import imgLogo from "/src/images/logo.svg";
import HeaderSp from "./HeaderSp";
import Search from "./component-search-result";

const Header = ({ siteTitle, location, languages, cnm, pathWithoutLang }) => {
  //const [isOpen, setOpen] = useState(false)
  const intl = useIntl();
  //const pathWithoutLang = location.pathname.replace(/\/de/g, '')
  //const classNameForHeader = pathWithoutLang === "/" ? "top" : pathWithoutLang.replace(/\//g, '')

  //const [changeLocaleLang, setChangeLocaleLang] = useState(intl.locale);

  const handleChange = (e) => {
    console.log(e.target.value);
    changeLocale(e.target.value);
  };

  const [hover, setHover] = useState(false);
  //const mouseEnterHandler = (e) => {
  //  setHover(true);
  //};
  //const mouseLeaveHandler = (e) => {
  //  setHover(false);
  //};
  const getHoverCss = () => {
    return hover === true ? "hover" : "";
  };

  return (
    <>
      <header
        id="commonHeader"
        className={`header-${cnm} ${getHoverCss()}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        role = "toolbar"
      >
        <div className="headerInner">
          <h1>
            <Link to="/">
              <img src={imgLogo} className="ImgHeaderLogo" alt="company logo" />
            </Link>
          </h1>
          {/* https://try-m.co.jp/blog/web-create/2391/ */}
          <nav id="gnav">
            <ul>
              <li
                className={`mainCategoryTitle ${
                  pathWithoutLang.match(/products/) && "active"
                }`}
              >
                <Link
                  to="/products/"
                  className="mainCategoryTitle inactive init-bottom"
                >
                  <span>{intl.locale === "en" ? `Products` : `Produkte`}</span>
                </Link>
                <div className="menu menu-product flex-row">
                  <div className="flex-column-5 flexbox">
                    <ul className="menu_inner">
                      <li
                        className={`subCategoryTitle subCategoryTitle_child ${
                          pathWithoutLang.match(
                            "/products/medical-device/hal-motion-principal/"
                          ) && "active"
                        }`}
                      >
                        <Link to="/products/medical-device/hal-motion-principal/">
                          {intl.locale === "en"
                            ? `Medical device`
                            : `Medizinische Produkte`}
                        </Link>
                      </li>
                      <li
                        className={`subCategoryTitle ${
                          pathWithoutLang.match(
                            "/products/non-medical-device/"
                          ) && "active"
                        }`}
                      >
                        <Link to="/products/non-medical-device/">
                          {intl.locale === "en"
                            ? `Non-medical device`
                            : `Nichtmedizinische Produkte`}
                        </Link>
                      </li>
                      <li
                        className={`subCategoryTitle ${
                          pathWithoutLang.match("/products/cleaning-robot/") &&
                          "active"
                        }`}
                      >
                        <Link to="/products/cleaning-robot/">
                          {intl.locale === "en"
                            ? `Self-driving cleaning robot`
                            : `Selbstfahrender Reinigungsroboter`}
                        </Link>
                      </li>
                      <li
                        className={`subCategoryTitle ${
                          pathWithoutLang.match("/products/communication/") &&
                          "active"
                        }`}
                      >
                        <Link to="/products/communication/">
                          {intl.locale === "en"
                            ? `Communication`
                            : `Kommunikation`}
                        </Link>
                      </li>
                      <li
                        className={`subCategoryTitle ${
                          pathWithoutLang.match("/products/imaging/") &&
                          "active"
                        }`}
                      >
                        <Link to="/products/imaging/">
                          {intl.locale === "en"
                            ? `Imaging and detection`
                            : `Bildgebung und Früherkennung`}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="flex-column-7 flexbox flexboxRight">
                    <ul className="menu_inner-product flex-row">
                      <li className="subSubCategory flex-column-4">
                        <Link
                          to="/products/medical-device/hal-motion-principal/"
                          className="subSubCategoryInner"
                        >
                          <StaticImage
                            src="../images/MicrosoftTeams-image_11.png"
                            alt={siteTitle}
                            className="ImgHeaderProduct"
                            loading="eager"
                            quality={45}
                          />
                          <p>
                            {intl.locale === "en"
                              ? `Motion Priniple of HAL`
                              : `Bewegungsprinzip des HAL`}
                          </p>
                          <p>
                            {intl.locale === "en"
                              ? `When a person tries to move, signals sent from brain to the muscles trickle onto the surface of the skin as very faint bio-electrical signals, and HAL is capable of detecting these signals to complete the motion of patients.`
                              : `Versucht eine Person sich zu bewegen, erscheinen Signale die vom Gehirn an den Muskel gesendet werden, als schwache bioelektrische Signale auf der Hautoberfläche. HAL kann diese Signale erkennen und verarbeiten, um die beabsichtigte Bewegung zu vollenden.`}
                          </p>
                        </Link>
                      </li>
                      <li className="subSubCategory flex-column-4">
                        <Link
                          to="/products/medical-device/hal-joint/"
                          className="subSubCategoryInner"
                        >
                          <StaticImage
                            src="../images/MicrosoftTeams-image_8.png"
                            alt={siteTitle}
                            className="ImgHeaderProduct"
                            loading="eager"
                            quality={45}
                          />
                          <p>
                            {intl.locale === "en"
                              ? `HAL Single Joint`
                              : `HAL Single Joint`}
                          </p>
                          <p>
                            {intl.locale === "en"
                              ? `Its portable and lightweight design makes it possible to start HAL therapy in the super-acute phase. Utilising HAL Single Joint aims to accelerate recovery and improve prognosis.`
                              : `Das portable und leichte Design ermöglicht es die HAL-Therapie schon in der Frühphase einzusetzten. Der Einsatz des HAL Single Joints zielt darauf ab die Genesung zu beschleunigen und die Prognose zu verbessern.`}
                          </p>
                        </Link>
                      </li>
                      <li className="subSubCategory flex-column-4">
                        <Link
                          to="/products/medical-device/hal-limb/"
                          className="subSubCategoryInner"
                        >
                          <StaticImage
                            src="../images/MicrosoftTeams-image_9.png"
                            alt={siteTitle}
                            className="ImgHeaderProduct"
                            loading="eager"
                            quality={45}
                          />
                          <p>
                            {intl.locale === "en"
                              ? `HAL Lower Limb Type`
                              : `HAL Lower Limb Type`}
                          </p>
                          <p>
                            {intl.locale === "en"
                              ? `HAL Lower Limb (HAL-ML05), a neurological device helps the patients regain the natural movement of their paretic or paralyzed legs based on their intention.`
                              : `HAL Lower Limb (HAL-ML05), ein neurologisches Gerät, hilft den Patienten, die natürliche Bewegung ihrer gelähmten oder paretischen Beine auf der Grundlage ihrer Absicht wiederzuerlangen.`}
                          </p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li
                className={`mainCategoryTitle ${
                  pathWithoutLang.match(/treatment/) && "active"
                }`}
              >
                <Link
                  to="/treatment/cvd/"
                  className="mainCategoryTitle inactive"
                >
                  <span>
                    {intl.locale === "en" ? `HAL Treatment` : `HAL Treatment`}
                  </span>
                </Link>
                <div className="menu">
                  <ul className="menu_inner">
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/treatment/cvd/") && "active"
                      }`}
                    >
                      <Link to="/treatment/cvd/">
                        {intl.locale === "en"
                          ? `Cerebrovascular disease (CVD)`
                          : `Zerebrovaskulären Erkrankungen`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/treatment/spinal/") && "active"
                      }`}
                    >
                      <Link to="/treatment/spinal/">
                        {intl.locale === "en"
                          ? `Spinal cord injury`
                          : `Rückenmarksverletzungen`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/treatment/pnd/") && "active"
                      }`}
                    >
                      <Link to="/treatment/pnd/">
                        {intl.locale === "en"
                          ? `Progressive neuromuscular diseases`
                          : `Progressive neuromuskuläre Erkrankungen `}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/treatment/znb/") && "active"
                      }`}
                    >
                      <Link to="/treatment/znb/">
                        {intl.locale === "en"
                          ? `About ZNB/ Our therapists`
                          : `Das ZNB / Unsere Therapeuten`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/treatment/testimonials/") &&
                        "active"
                      }`}
                    >
                      <Link to="/treatment/testimonials/">
                        {intl.locale === "en"
                          ? `Testimonials`
                          : `Erfahrungsberichte`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/treatment/faq/") && "active"
                      }`}
                    >
                      <Link to="/treatment/faq/">
                        {intl.locale === "en"
                          ? `Frequently Asked Questions`
                          : `Häufig gestellte Fragen (FAQ)`}
                      </Link>
                    </li>
                    {/* <li className="subCategoryTitle"><Link to="/treatment/info/">Information for visitors</Link></li> */}
                  </ul>
                </div>
              </li>
              <li
                className={`mainCategoryTitle ${
                  pathWithoutLang.match(/training/) && "active"
                }`}
              >
                <Link
                  to="/training/elderly/"
                  className="mainCategoryTitle inactive"
                >
                  <span>
                    {intl.locale === "en" ? `Neuro HALFIT` : `Neuro HALFIT`}
                  </span>
                </Link>
                <div className="menu">
                  <ul className="menu_inner">
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/training/elderly/") && "active"
                      }`}
                    >
                      <Link to="/training/elderly/">
                        {intl.locale === "en"
                          ? `Mobility Wellness`
                          : `Bewegungswohlbefinden`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/training/athletes/") && "active"
                      }`}
                    >
                      <Link to="/training/athletes/">
                        {intl.locale === "en"
                          ? `Athletic Performance`
                          : `Sportliche Leistungsfähigkeit`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                className={`mainCategoryTitle ${
                  pathWithoutLang.match("/company/") && "active"
                }`}
              >
                <Link to="/company/about/" className="mainCategoryTitle">
                  <span>
                    <FormattedMessage id="common.AboutUs" />
                  </span>
                </Link>
                <div className="menu">
                  <ul className="menu_inner">
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/company/about/") && "active"
                      }`}
                    >
                      <Link to="/company/about/">
                        {intl.locale === "en" ? `About us` : `Über uns`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match(/company\/$/) && "active"
                      }`}
                    >
                      <Link to="/company/">
                        {intl.locale === "en"
                          ? `Cyberdyne Inc.`
                          : `Cyberdyne Inc.`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/company#founder") && "active"
                      }`}
                    >
                      <Link to="/company#founder">
                        {intl.locale === "en" ? `Founder` : `Gründer`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/company/mission/") && "active"
                      }`}
                    >
                      <Link to="/company/mission/">
                        {intl.locale === "en"
                          ? `Vision and Mission`
                          : `Vision und Auftrag`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/company/cybernics/") && "active"
                      }`}
                    >
                      <Link to="/company/cybernics/">
                        {intl.locale === "en" ? `Cybernics` : `Cybernics`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/company/access/") && "active"
                      }`}
                    >
                      <Link to="/company/access/">
                        {intl.locale === "en" ? `Access` : `Anfahrt`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                className={`mainCategoryTitle ${
                  pathWithoutLang.match(/news/) && "active"
                }`}
              >
                <Link to="/news/" className="mainCategoryTitle">
                  <span>
                    <FormattedMessage id="common.News" />
                  </span>
                </Link>
                <div className="menu">
                  <ul className="menu_inner">
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/news/") && "active"
                      }`}
                    >
                      <Link to="/news/">
                        {intl.locale === "en" ? `Latest News` : `Aktuelles`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/research/") && "active"
                      }`}
                    >
                      <Link to="/research/">
                        {intl.locale === "en"
                          ? `Clinical Publications`
                          : `Klinische Studien`}
                      </Link>
                    </li>
                    <li
                      className={`subCategoryTitle ${
                        pathWithoutLang.match("/recruit/") && "active"
                      }`}
                    >
                      <Link to="/recruit/">
                        {intl.locale === "en" ? `Recruiting` : `Karriere`}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className={`${pathWithoutLang.match(/contact/) && "active"}`}>
                <Link to="/contact/" className="mainCategoryTitle">
                  <span>
                    <FormattedMessage id="common.contact" />
                  </span>
                </Link>
              </li>
              <li className="toggle search-li">
                <div className="searchIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <g stroke="" stroke-width="2">
                        <g transform="translate(-1502.000000, -39.000000) translate(1503.000000, 40.000000)">
                          <circle cx="8.029" cy="8.029" r="8.029" />
                          <path
                            stroke-linecap="square"
                            d="M14.206 14.206L19.799 19.799"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>

                <Search />
                
              </li>
              <li className="changeLocale">
                <div className="cp_ipselect cp_sl01">
                  <select
                    required
                    onChange={handleChange}
                    defaultValue={intl.locale}
                  >
                    <option value="de">
                      DE
                    </option>
                    <option value="en">
                      EN
                    </option>
                  </select>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <HeaderSp location={location} pathWithoutLang={pathWithoutLang} />
    </>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
